export interface QuickMessage {
  id: string;
  label: string;
  message: string;
  keywords: string[]; // Keywords for "/" command matching
}

export const QUICK_MESSAGES: QuickMessage[] = [
  {
    id: 'rejection_accident',
    label: 'رفض - حادث',
    message: `عزيزي العميل،
نود إفادتكم بأنه تم رفض طلب الخدمة، حيث تبيّن أن حالة المركبة تُصنَّف كحادث.

خدمة المساعدة على الطريق لا تشمل الحوادث لتأمين ( الطرف الثالث )  (Third Party Insurance).
الخدمة مخصصة فقط لحالات الأعطال والطوارئ، وتشمل:
•⁠  ⁠نقل المركبة في حالات الأعطال
•⁠  ⁠فتح قفل المركبة
•⁠  ⁠تزويد الوقود
•⁠  ⁠تشغيل البطارية
•⁠  ⁠نقل المركبة إلى أقرب محل إطارات

نشكركم لتفهمكم، ويسعدنا خدمتكم في الحالات المشمولة بالخدمة.`,
    keywords: ['حادث', 'accident', 'رفض', 'reject', 'third party', 'طرف ثالث']
  },
  {
    id: 'rejection_industrial',
    label: 'رفض - منطقة صناعية',
    message: `عزيزي العميل،
نود إعلامكم بأنه تم رفض طلبكم نظرًا لوجود المركبة في منطقة صناعية او ورشة اصلاح .
نعتذر  عن  تقديم خدمة النقل بين الورش أو المناطق الصناعية، وذلك لمخالفة الشروط والأحكام المعتمدة لدينا.

لأي استفسارات إضافية، لا تتردد في التواصل معنا.
نشكر تفهمكم وتعاونكم.

مع أطيب التحيات،
فريق خدمة العملاء
شركة درب للخدمات الوطنية`,
    keywords: ['صناعية', 'industrial', 'ورشة', 'workshop', 'منطقة', 'area']
  },
  {
    id: 'rejection_mountain',
    label: 'رفض - منطقة جبلية',
    message: `عزيزي العميل،

نود إعلامكم بأنه تم رفض طلبكم نظرًا لمخالفة الخدمة للشروط والأحكام المعتمدة، حيث إن خدمة المساعدة على الطريق لا تشمل المناطق الجبلية أو التي تحتوي على عقبات.

نعتذر عن أي إزعاج قد يسببه ذلك، ونؤكد حرصنا على خدمتكم متى ما كانت المركبة ضمن نطاق التغطية المشمول بالخدمة.

مع خالص التحية،
فريق خدمة العملاء
شركة درب للخدمات الوطنية`,
    keywords: ['جبلية', 'mountain', 'عقبات', 'obstacles', 'مناطق', 'areas']
  },
  {
    id: 'rejection_mountain_en',
    label: 'Rejection - Mountain Area (EN)',
    message: `Dear Customer,

We would like to inform you that your request has been declined as it does not comply with the approved terms and conditions.
Please note that roadside assistance service does not cover mountainous areas or locations with steep slopes.

We apologize for any inconvenience this may cause and assure you that we are always ready to assist you whenever the vehicle is within the covered service area.

Kind regards,
Customer Service Team
Darb National Services LLC`,
    keywords: ['mountain', 'mountainous', 'steep', 'slopes', 'declined', 'rejection']
  },
  {
    id: 'rejection_accident_en',
    label: 'Rejection - Accident (EN)',
    message: `Dear Customer,
We would like to inform you that your service request has been rejected, as the vehicle condition is classified as an accident.

Roadside Assistance service does not cover accidents for Third Party Insurance policyholders.
The service is strictly limited to breakdowns and emergency cases only, including:
•⁠  ⁠Vehicle towing in case of breakdowns
•⁠  ⁠Vehicle door unlocking
•⁠  ⁠Emergency fuel delivery
•⁠  ⁠Battery jump-start
•⁠  ⁠Towing the vehicle to the nearest tire shop

Thank you for your understanding.`,
    keywords: ['accident', 'rejected', 'third party', 'insurance', 'breakdown']
  },
  {
    id: 'rejection_industrial_en',
    label: 'Rejection - Industrial Area (EN)',
    message: `Dear Customer,

We would like to inform you that your request has been declined, as the vehicle is located in an industrial area.
Please note that we are unable to provide towing services between workshops or within industrial zones, in accordance with our approved terms and conditions.

For any further inquiries, please do not hesitate to contact us.
We appreciate your understanding and cooperation.

Kind regards,
Customer Service Team
Darb National Services LLC`,
    keywords: ['industrial', 'workshop', 'zone', 'declined', 'towing']
  }
];

// Helper function to find messages matching a search query
export const findMatchingMessages = (query: string): QuickMessage[] => {
  if (!query || query.trim() === '') return QUICK_MESSAGES;
  
  const lowerQuery = query.toLowerCase().trim();
  
  return QUICK_MESSAGES.filter(msg => 
    msg.keywords.some(keyword => keyword.toLowerCase().includes(lowerQuery)) ||
    msg.label.toLowerCase().includes(lowerQuery) ||
    msg.message.toLowerCase().includes(lowerQuery)
  );
};
